/** Whether the visitor has asked for reduced motion. Client-only (reads
 *  matchMedia); the landing arms call it from effects and event handlers. */
export const prefersReducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
